<script>
import { getModule } from '@/modules/store'
import ConfigStore from '@/modules/config/store/ConfigStore'

export default {
    data() {
        return {
            scriptEl: null
        }
    },
    render() {
        return this.$slots.default
    },
    async mounted() {
        window.CRISP_RUNTIME_CONFIG = {
            locale: this.configStore.userLanguage,
            session_merge : true
        }
        let crispActions = []
        crispActions.push(
            [
                "set",
                "user:email",
                [this.configStore.user.email]
            ]
        )
        crispActions.push(
            [
                "set",
                "user:nickname",
                [this.configStore.user.firstName + ' ' + this.configStore.user.lastName]
            ]
        )

        window.$crisp = crispActions
        window.CRISP_WEBSITE_ID = "ad0a1489-8a2f-43d9-a234-5e9f099315da"
        window.CRISP_TOKEN_ID = await this.digestMessage(this.configStore.user.userId)
        this.createCrisp()
        this.$eventBusOn('logout', () => {
            window.CRISP_TOKEN_ID = ''
        })
    },
    computed: {
        configStore() {
            return getModule(ConfigStore)
        },
        cripsInstance() {
            return window.$crisp
        }
    },
    methods: {
        createCrisp() {
            this.scriptEl = document.createElement("script")
            this.scriptEl.src = "https://client.crisp.chat/l.js"
            this.scriptEl.async = 1
            document.getElementsByTagName("head")[0].appendChild(this.scriptEl)
        },
        async digestMessage(message) {
            const msgUint8 = new TextEncoder().encode(message)                              // encode as (utf-8) Uint8Array
            const hashBuffer = await crypto.subtle.digest('SHA-256', msgUint8)              // hash the message
            const hashArray = Array.from(new Uint8Array(hashBuffer))                        // convert buffer to byte array
            const hashHex = hashArray.map(b => b.toString(16).padStart(2, '0')).join('')    // convert bytes to hex string
            return hashHex
        }
    }
}
</script>



// WEBPACK FOOTER //
// src/modules/app/components/Crisp.vue